import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { useIntl } from "react-intl";

export function TextCell(props) {
  let formattedContent;

  try {
    const intl = useIntl();
    formattedContent = intl.formatMessage({
      id: parse(props.text),
      defaultMessage: parse(props.text),
      description: "",
    });
  } catch (error) {
    formattedContent = parse(props.text);
  }

  return (
    <td className={props.className} colspan={props.colspan}>
      <div className={`dataTable_row_fixed_contents`}>
        <p>{formattedContent}</p>
      </div>
    </td>
  );
}

TextCell.propTypes = {
  /**
   * Text to be displayed on the cell
   */
  text: PropTypes.string,
  /**
   * className to be set on the cell
   */
  className: PropTypes.string,
};
